/* GK · Taller en vivo (1-nov-2026) */
  (function () {
    var root = document.querySelector('.gkt');
    if (!root || root.dataset.init) return;
    root.dataset.init = '1';

    var sticky = root.querySelector('[data-gkt-sticky]');
    var tiers = root.querySelector('#niveles');
    if (sticky && tiers && 'IntersectionObserver' in window) {
      var past = false, inTiers = false;
      var hero = root.querySelector('.gkt-hero');
      new IntersectionObserver(function (e) { past = !e[0].isIntersecting; sync(); }).observe(hero);
      new IntersectionObserver(function (e) { inTiers = e[0].isIntersecting; sync(); }).observe(tiers);
      function sync() { sticky.classList.toggle('is-on', past && !inTiers); }
    }

    var field = root.querySelector('.gkt-wa-field');
    var input = field && field.querySelector('input');
    var err = field && field.querySelector('.gkt-wa-error');
    root.querySelectorAll('[data-gkt-buy]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var num = input ? input.value.replace(/[^\d+]/g, '') : '';
        if (input && num.replace(/\D/g, '').length < 9) {
          field.classList.add('is-error'); err.hidden = false;
          field.scrollIntoView({ behavior: 'smooth', block: 'center' }); input.focus();
          return;
        }
        if (field) { field.classList.remove('is-error'); err.hidden = true; }
        btn.disabled = true;
        var label = btn.textContent; btn.textContent = 'Un momento…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(btn.dataset.variantId), quantity: 1, properties: { 'WhatsApp': num } }] })
        }).then(function (r) {
          if (!r.ok) throw new Error('add');
          window.location.href = '/checkout';
        }).catch(function () {
          btn.disabled = false; btn.textContent = label;
          alert('No se pudo agregar. Escríbenos por WhatsApp y te inscribimos.');
        });
      });
    });
  })();
